"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = assertObject;

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function assertObject(value) {
  var label = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'value';

  if (_typeof(value) !== 'object' || Array.isArray(value)) {
    throw new TypeError("".concat(label, " needs to be a plain object"));
  }
}